<template>
  <div class="content">
    <resource-box :name="title">
      <span slot="back" @click="$emit('close', true)" class="closeDom">
        <i class="el-icon-close"></i>
      </span>
      <div class="overview" slot="content">
        <div class="companyHeader">
          <div class="companyImg">
            <img :src="imgUrl" alt="" />
          </div>
          <div class="companyInfo">
            <div class="title">{{ storeInfo.name }}</div>
            <div class="Description">{{ storeInfo.address }}</div>
          </div>
        </div>
        <div class="companyContent">
          <!-- 数据长度小于等于2条时，直接展示 -->
          <template v-if="storeList.length <= 2">
            <div class="storeInfo" v-for="item in storeList" :key="item.name">
              <p class="storeName">{{ item.name }}</p>
              <p class="storeAmount">
                <span>{{ item.amount }}</span
                ><span class="units">{{ item.unit }}</span>
              </p>
            </div>
          </template>

          <!-- 数据长度大于2条时，使用 el-carousel 轮播展示 -->
          <template v-else>
            <el-carousel
              :interval="3000"
              arrow="always"
              style="width: 100%"
              indicator-position="none"
              height="72px"
            >
              <el-carousel-item
                v-for="(group, index) in groupedStoreList"
                :key="index"
              >
                <div class="storeGroup">
                  <div class="storeInfo" v-for="item in group" :key="item.name">
                    <p class="storeName">{{ item.name }}</p>
                    <p class="storeAmount">
                      <span>{{ item.amount }}</span
                      ><span class="units">{{ item.unit }}</span>
                    </p>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </template>
        </div>
        <div class="companyBackGround">
          <img v-if="!getVideoUrl(storeInfo.name)" :src="backgroundUrl" alt="" />
          <video v-else width="100%" id="echartsMp4" height="100%" controls>
            <source id="source" :src="getVideoUrl(storeInfo.name)" type="video/mp4" />
            您的浏览器不支持 HTML5 视频
          </video>
        </div>
      </div>
    </resource-box>
  </div>
</template>

<script>
import resourceBox from '@/views/ChinaMapData/components/common/resourceBox.vue';
export default {
  name: 'detailsCard',
  components: {
    resourceBox,
  },
  props: {
    storeList: {
      type: Array,
      default: () => [],
    },
    storeInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    // 将数据按每组2条进行分组
    groupedStoreList() {
      const groups = [];
      const chunkSize = 2; // 每组展示2条数据
      for (let i = 0; i < this.storeList.length; i += chunkSize) {
        groups.push(this.storeList.slice(i, i + chunkSize));
      }
      return groups;
    },
  },
  data() {
    return {
      title: '',
      imgUrl: require('@/assets/recycling/chinaMap/companyIcon.svg'),
      backgroundUrl: require('@/assets/recycling/chinaMap/componyBackground.svg'),
    };
  },
  methods: {
    getVideoUrl(name) {
      const storeName = [
        { name: '什邡仓库', url: 'shifangcangku' },
        { name: '绵阳仓库', url: 'mianyangcangku' },
      ];
      let videoUrl;
      storeName.forEach((item) => {
        if (item.name === name) {
          videoUrl = `${window.location.origin}/apisix/files/video/${item.url}.mp4`;
        }
      });
      return videoUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.closeDom {
  padding: 10px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.content {
  width: 462px;
  height: 445px;
  background: linear-gradient(
    180deg,
    rgba(14, 74, 50, 0.8) 0%,
    rgba(15, 66, 43, 0.5) 100%
  );
}
.overview {
  padding: 25px;
}
.companyHeader {
  height: 70px;
  display: flex;
  width: 100%;
}
.companyImg {
  height: inherit;
  width: 70px;
  border: 1px solid rgba(59, 77, 68, 1);
  background-color: rgb(2, 22, 42);
  border-radius: 3px;
  img {
    height: inherit;
    width: inherit;
  }
}
.companyInfo {
  height: inherit;
  width: calc(100% - 90px);
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .title {
    width: 100%;
    font-size: 20px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  .Description {
    width: 100%;
    font-size: 14px;
    color: rgba(153, 206, 251, 1);
  }
}
.companyContent {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 20px;
  .storeInfo {
    width: 198px;
    height: 72px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: linear-gradient(
      270deg,
      rgba(2, 79, 42, 0) 0%,
      rgba(4, 51, 27, 1) 49.79%,
      rgba(2, 79, 42, 0) 100%
    );
    border: 1px solid rgba(7, 74, 42, 1);
    .storeName {
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      width: 100%;
    }
    .storeAmount {
      width: 100%;
      font-size: 28px;
      font-weight: 700;
      line-height: 28px;
      color: rgba(216, 216, 216, 1);
      text-align: center;
    }
  }
}
.companyBackGround {
  width: 412px;
  height: 178px;
  opacity: 1;
  margin-top: 20px;
  img {
    width: inherit;
    height: inherit;
  }
}
.storeGroup {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.units {
  font-size: 14px;
  padding-left: 5px;
}
</style>
